export const SAVE_ROUTINE_DRAFT = `
  mutation SaveRoutineDraft($input: SaveRoutineDraftInput!) {
    routine {
      saveRoutineDraft(input: $input) {
        success
        message
        draftId
      }
    }
  }
`;

export const DELETE_ROUTINE_DRAFT = `
  mutation DeleteRoutineDraft($input: DeleteRoutineDraftInput!) {
    routine {
      deleteRoutineDraft(input: $input) {
        success
        message
      }
    }
  }
`;

export const FIND_ROUTINE_DRAFT = `
  query FindRoutineDraft($workspaceAssetId: ID!, $routineId: ID!) {
    routine {
      findRoutineDraft(workspaceAssetId: $workspaceAssetId, routineId: $routineId) {
        id
        data
        isDraft
        createdAt
        updatedAt
        createdBy {
          id
          name {
            first
            last
          }
        }
        updatedBy {
          id
          name {
            first
            last
          }
        }
      }
    }
  }
`;

export const FIND_ROUTINE_DRAFTS_BY_ASSET = `
  query FindRoutineDraftsByAsset($filter: AssetRoutineFilter) {
    findAssetRoutines(filter: $filter) {
      items {
        id
        routine {
          id
        }
      }
    }
  }
`;
